module.exports = __webpack_public_path__ + "static/1_3-b4631f50b8e457dabaaf0b15d9b2ab15.mp4";